export default {
  HelpTemplate: [
    {
      help_link_name: 'Thông tin đơn vị',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/thiet-lap-thong-tin-don-vi/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=thiet-lap-thong-tin-don-vi',
      router_bumas: 'UnitInfomationPopup',
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Quản lý người dùng',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/quan-ly-nguoi-dung/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=quan-ly-nguoi-dung',
      router_bumas: null,
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Quản lý vai trò',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/quan-ly-vai-tro/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=quan-ly-vai-tro',
      router_bumas: null,
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Đơn vị trực thuộc',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-truc-thuoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-truc-thuoc',
      router_bumas: '/organizationunder',
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Bảo mật nâng cao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/bao-mat-nang-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=bao-mat-nang-cao',
      router_bumas: null,
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Thiết lập chữ ký số',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/thiet-lap-chu-ky-so/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=thiet-lap-chu-ky-so',
      router_bumas: null,
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Thiết lập hiển thị',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/thiet-lap-hien-thi/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=thiet-lap-hien-thi',
      router_bumas: 'SettingDisplayPopup',
      organization_pack_code_type: [1, 2, 3, 4, 5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Thiết lập danh mục ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-thiet-lap-danh-muc-thu-chi-mlns/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-thiet-lap-danh-muc-thu-chi-mlns',
      router_bumas: '/dictionaryV3',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận hướng dẫn lập dự toán từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-nhan-huong-dan-lap-du-toan-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-nhan-huong-dan-lap-du-toan-tu-cap-tren',
      router_bumas: '/sync-dictionary',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu NSNN',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-thu-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-thu-nsnn',
      router_bumas: '/dictionaryV3/dictionaryRevenueBudget',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-thu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-thu-khac',
      router_bumas: '/dictionaryV3/revenueOtherList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-chi-dau-tu-phat-trien/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-chi-dau-tu-phat-trien',
      router_bumas: '/dictionaryV3/expenseInvest',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-chi-thuong-xuyen',
      router_bumas: '/dictionaryV3/dictionaryRegularList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-chi-ctmt-da-muc-tieu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-chi-ctmt-da-muc-tieu-khac',
      router_bumas: '/dictionaryV3/projectExpenseList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-chi-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-chi-khac',
      router_bumas: '/dictionaryV3/dictionaryExpenseOtherList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục MLNS',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-muc-luc-ngan-sach/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-muc-luc-ngan-sach',
      router_bumas: '/MLNS',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thuyết minh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-danh-muc-thuyet-minh/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-danh-muc-thuyet-minh',
      router_bumas: '/dictionaryV3/dictionaryExplanation',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Tiêu chí thống kê',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-tieu-chi-thong-ke/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-tieu-chi-thong-ke',
      router_bumas: '/dictionaryV3/criteriaList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Mẫu in tùy chỉnh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-thiet-lap-mau-in/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-thiet-lap-mau-in',
      router_bumas: '/dictionaryV3/dictionaryReportCustomList',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu NSNN',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-lap-du-toan-thu-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-lap-du-toan-thu-nsnn',
      router_bumas: 'EstimateBudget',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-lap-du-toan-thu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-lap-du-toan-thu-khac',
      router_bumas: 'RevenueOther',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi đầu tư ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-lap-du-toan-chi-dau-tu-phat-trien/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-lap-du-toan-chi-dau-tu-phat-trien',
      router_bumas: 'EstimateInvest',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-lap-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-lap-du-toan-chi-thuong-xuyen',
      router_bumas: 'ExpenseRegular',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi CTMT, Mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-lap-du-toan-chi-ctmt-muc-tieu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-lap-du-toan-chi-ctmt-muc-tieu-khac',
      router_bumas: 'ExpenseProgram',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-lap-du-toan-chi-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-lap-du-toan-chi-khac',
      router_bumas: 'ExpenseEstimateOtherByLaw',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Tổng hợp dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-tong-hop-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-tong-hop-du-toan',
      router_bumas: '/begin-year/totalEstimate',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nộp cấp trên và xem kết quả',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-nop-va-xem-ket-qua/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-nop-va-xem-ket-qua',
      router_bumas: '/begin-year/submitEstimate',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận phương án phân bổ từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-nhan-phuong-an-phan-bo-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-nhan-phuong-an-phan-bo-tu-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-thuc-hien-phan-bo/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-thuc-hien-phan-bo',
      router_bumas: null,
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'In báo cáo',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-in-bao-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-in-bao-cao',
      router_bumas: '/report',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập báo cáo theo biểu mẫu cấp trên ban hành',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-phuong-lap-bieu/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-phuong-lap-bieu',
      router_bumas: null,
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhập khẩu dữ liệu năm trước',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/xa-nhap-du-lieu-nam-truoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=xa-nhap-du-lieu-nam-truoc',
      router_bumas: '/beforedata',
      organization_pack_code_type: [3],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập danh mục ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-thiet-lap-danh-muc-thu-chi-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-thiet-lap-danh-muc-thu-chi-nsnn/',
      router_bumas: '/dictionaryV3',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận hướng dẫn lập dự toán từ cấp trên',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-nhan-huong-dan-lap-du-toan-tu-cap-tren/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-nhan-huong-dan-lap-du-toan-tu-cap-tren',
      router_bumas: '/sync-dictionary',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu HĐSN, dịch vụ',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thu-hdsn-dich-vu/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thu-hdsn-dich-vu',
      router_bumas: '/dictionaryV3/dictionaryBusinessList',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu Phí, lệ phí',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thu-phi-le-phi/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thu-phi-le-phi',
      router_bumas: '/dictionaryV3/dictionaryFees',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi đầu tư phát triển',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-dau-tu-phat-trien/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-dau-tu-phat-trien',
      router_bumas: '/dictionaryV3/expenseInvest',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi thường xuyên',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-thuong-xuyen/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-thuong-xuyen',
      router_bumas: '/dictionaryV3/dictionaryRegularList',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi CTMT, mục tiêu khác',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-ctmt-muc-tieu-khac/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-chi-ctmt-muc-tieu-khac',
      router_bumas: '/dictionaryV3/projectExpenseList',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục MLNS',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-muc-luc-ngan-sach/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-muc-luc-ngan-sach',
      router_bumas: '/MLNS',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thuyết minh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thuyet-minh/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-thuyet-minh',
      router_bumas: '/dictionaryV3/dictionaryExplanation',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Tiêu chí thống kê',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-tieu-chi-thong-ke/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-danh-muc-tieu-chi-thong-ke',
      router_bumas: '/dictionaryV3/criteriaList',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Mẫu in tùy chỉnh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thiet-lap-mau-in/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thiet-lap-mau-in',
      router_bumas: '/dictionaryV3/dictionaryReportCustomList',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-lap-du-toan-chi-phat-trien/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-lap-du-toan-chi-phat-trien',
      router_bumas: 'EstimateInvest',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-lap-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-lap-du-toan-chi-thuong-xuyen',
      router_bumas: 'ExpenseRegular',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-lap-du-toan-chi-ctmt-muc-tieu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-lap-du-toan-chi-ctmt-muc-tieu-khac',
      router_bumas: 'ExpenseProgram',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán nguồn phí, lệ phí',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-lap-du-toan-nguon-phi-le-phi/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-lap-du-toan-nguon-phi-le-phi',
      router_bumas: 'RevenueExpenseFees',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán nguồn HĐSN, DV',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-du-toan-nguon-hoat-dong-su-nghiep-dich-vu/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-du-toan-nguon-hoat-dong-su-nghiep-dich-vu',
      router_bumas: 'EstimateExpenseBusiness',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Tổng hợp dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvns-tong-hop-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvns-tong-hop-du-toan',
      router_bumas: '/begin-year/totalEstimateHcsn',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nộp cấp trên và xem kết quả',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-nop-va-xem-ket-qua/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-nop-va-xem-ket-qua',
      router_bumas: '/begin-year/submitEstimate',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận phương án phân bổ từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-nhan-phuong-an-phan-bo-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-nhan-phuong-an-phan-bo-tu-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-su-dung-ngan-sach-thuc-hien-phan-bo-du-toan/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-su-dung-ngan-sach-thuc-hien-phan-bo-du-toan',
      router_bumas: null,
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'In báo cáo',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dv-cap-duoi-in-bao-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dv-cap-duoi-in-bao-cao',
      router_bumas: '/report',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập báo cáo theo biểu mẫu cấp trên ban hành',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-hcsn-cap-duoi-lap-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-hcsn-cap-duoi-lap-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhập khẩu dữ liệu năm trước',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcd-nhap-du-lieu-nam-truoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcd-nhap-du-lieu-nam-truoc',
      router_bumas: '/beforedata',
      organization_pack_code_type: [4],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập danh mục ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-thiet-lap-danh-muc-thu-chi-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-thiet-lap-danh-muc-thu-chi-nsnn/',
      router_bumas: '/dictionaryV3',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận hướng dẫn lập dự toán từ cấp trên',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-tong-hop-du-toan-nhan-huong-dan-lap-du-toan-tu-cap-tren/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-tong-hop-du-toan-nhan-huong-dan-lap-du-toan-tu-cap-tren',
      router_bumas: '/sync-dictionary',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu HĐSN, dịch vụ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-thu-hdsn-dich-vu/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-thu-hdsn-dich-vu',
      router_bumas: '/dictionaryV3/dictionaryBusinessList',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu Phí, lệ phí',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-thu-phi-le-phi/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-thu-phi-le-phi',
      router_bumas: '/dictionaryV3/dictionaryFees',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-chi-dau-tu-phat-trien/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-chi-dau-tu-phat-trien',
      router_bumas: '/dictionaryV3/expenseInvest',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-chi-thuong-xuyen/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-chi-thuong-xuyen',
      router_bumas: '/dictionaryV3/dictionaryRegularList',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi CTMT, mục tiêu khác',
      url_help:
        'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-chi-ctmt-muc-tieu-khac/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-chi-ctmt-muc-tieu-khac',
      router_bumas: '/dictionaryV3/projectExpenseList',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục MLNS',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-muc-luc-ngan-sach/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-muc-luc-ngan-sach',
      router_bumas: '/MLNS',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thuyết minh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-thuyet-minh/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-thuyet-minh',
      router_bumas: '/dictionaryV3/dictionaryExplanation',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Tiêu chí thống kê',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-danh-muc-tieu-chi-thong-ke/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-danh-muc-tieu-chi-thong-ke',
      router_bumas: '/dictionaryV3/criteriaList',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Mẫu in tùy chỉnh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-thiet-lap-mau-in/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-thiet-lap-mau-in',
      router_bumas: '/dictionaryV3/dictionaryReportCustomList',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Ban hành hướng dẫn lập dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-tong-hop-du-toan-ban-hanh-huong-dan-lap-du-toan/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-tong-hop-du-toan-ban-hanh-huong-dan-lap-du-toan',
      router_bumas: '/dictionary-enact',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-lap-du-toan-chi-dau-tu-phat-trien/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-lap-du-toan-chi-dau-tu-phat-trien',
      router_bumas: 'EstimateInvestSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-lap-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-lap-du-toan-chi-thuong-xuyen',
      router_bumas: 'ExpenseRegularSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-lap-du-toan-chi-ctmt-muc-tieu-khac/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-lap-du-toan-chi-ctmt-muc-tieu-khac',
      router_bumas: 'ExpenseProgramSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán nguồn phí, lệ phí',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-lap-du-toan-nguon-phi-le-phi/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-lap-du-toan-nguon-phi-le-phi',
      router_bumas: 'RevenueExpenseFeesSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán nguồn HĐSN, DV',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-lap-du-toan-nguon-hdsn-dich-vu/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-lap-du-toan-nguon-hdsn-dich-vu',
      router_bumas: 'EstimateExpenseBusinessSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra dự toán ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-kiem-tra-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-kiem-tra-du-toan',
      router_bumas: '/examine',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Tổng hợp dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-tong-hop-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-tong-hop-du-toan',
      router_bumas: '/sector-wide-begin-year-estimate/summaryEstimateSectorWide',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nộp cấp trên và xem kết quả',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-nop-du-toan-va-xem-ket-qua/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-nop-du-toan-va-xem-ket-qua',
      router_bumas: '/sector-wide-begin-year-estimate/submitEstimate',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận phương án phân bổ từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-nhan-phuong-an-phan-bo-cua-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-nhan-phuong-an-phan-bo-cua-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-thuc-hien-phan-bo/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-thuc-hien-phan-bo',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập quyết định giao',
      // url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-hcsn-cap-tren-quyet-dinh-giao/',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-hcsn-cap-tren-quyet-dinh-giao',
      router_bumas: '/allocation-receive-scq',
      organization_pack_code_type: [5],
      is_gel_sys_setup: true,
    },
    {
      help_link_name: 'Theo dõi giao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvct-theo-doi-giao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvct-theo-doi-giao',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Theo dõi thực hiện dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-theo-doi-tinh-hinh-thuc-hien/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-theo-doi-tinh-hinh-thuc-hien',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhập khẩu dữ liệu năm trước',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/don-vi-chu-quan-nhap-khau-du-lieu-nam-truoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=don-vi-chu-quan-nhap-khau-du-lieu-nam-truoc',
      router_bumas: '/beforedata',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'In báo cáo',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-in-bao-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-in-bao-cao',
      router_bumas: '/report',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập và ban hành biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-thiet-lap-va-ban-hanh-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-thiet-lap-va-ban-hanh-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra và tổng hợp biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/dvcq-kiem-tra-va-tong-hop-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=dvcq-kiem-tra-va-tong-hop-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập danh mục ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-thiet-lap-danh-muc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-thiet-lap-danh-muc/',
      router_bumas: '/dictionaryV3',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận hướng dẫn lập dự toán từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-nhan-huong-dan-lap-du-toan-tu-cap-tren/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-nhan-huong-dan-lap-du-toan-tu-cap-tren',
      router_bumas: '/sync-dictionary',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu NSNN',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-thu-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-thu-nsnn',
      router_bumas: '/dictionaryV3/dictionaryRevenueBudget',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu Phí, lệ phí',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-thu-phi-le-phi/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-thu-phi-le-phi',
      router_bumas: '/dictionaryV3/dictionaryFees',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu HĐSN, dịch vụ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-thu-hdsn-dich-vu/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-thu-hdsn-dich-vu',
      router_bumas: '/dictionaryV3/dictionaryBusinessList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-thu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-thu-khac',
      router_bumas: '/dictionaryV3/revenueOtherList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-du-an-dau-tu-phat-trien/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-du-an-dau-tu-phat-trien',
      router_bumas: '/dictionaryV3/expenseInvest',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-chi-thuong-xuyen',
      router_bumas: '/dictionaryV3/dictionaryRegularList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-ctmt-muc-tieu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-ctmt-muc-tieu-khac',
      router_bumas: '/dictionaryV3/projectExpenseList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Chi khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-chi-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-chi-khac',
      router_bumas: '/dictionaryV3/dictionaryExpenseOtherList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục MLNS',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-muc-luc-ngan-sach/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-muc-luc-ngan-sach',
      router_bumas: '/MLNS',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Mẫu dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-mau-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-mau-du-toan-chi-thuong-xuyen',
      router_bumas: '/dictionaryV3/dictionaryPatternRegularList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Thuyết minh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-thuyet-minh/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-thuyet-minh',
      router_bumas: '/dictionaryV3/dictionaryExplanation',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Cơ sở tính',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-co-so-tinh/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-co-so-tinh',
      router_bumas: '/dictionaryV3/calculationBasis',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Danh mục Tiêu chí thống kê',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-danh-muc-tieu-chi-thong-ke/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-danh-muc-tieu-chi-thong-ke',
      router_bumas: '/dictionaryV3/criteriaList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Mẫu in tùy chỉnh',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-thiet-lap-mau-in/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-thiet-lap-mau-in',
      router_bumas: '/dictionaryV3/dictionaryReportCustomList',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Ban hành hướng dẫn lập dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-ban-hanh-huong-dan-lap-du-toan/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-ban-hanh-huong-dan-lap-du-toan',
      router_bumas: '/dictionary-enact',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu NSNN',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-lap-du-toan-thu-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-lap-du-toan-thu-nsnn',
      router_bumas: 'EstimateBudgetArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-lap-du-toan-thu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-lap-du-toan-thu-khac',
      router_bumas: 'RevenueOtherArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-lap-du-toan-chi-dau-tu/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-lap-du-toan-chi-dau-tu',
      router_bumas: 'EstimateInvestArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-lap-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-lap-du-toan-chi-thuong-xuyen',
      router_bumas: 'ExpenseRegularArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-lap-du-toan-chi-ctmt-muc-tieu-khac/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-lap-du-toan-chi-ctmt-muc-tieu-khac',
      router_bumas: 'ExpenseProgramArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-lap-du-toan-chi-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-lap-du-toan-chi-khac',
      router_bumas: 'ExpenseEstimateOtherByLawArrgrate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Cân đối dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-can-doi-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-can-doi-du-toan',
      router_bumas: '/begin-year-arrgrate/summaryEstimateArrgratePTC',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra dự toán ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-kiem-tra-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-kiem-tra-du-toan',
      router_bumas: '/examine',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Tổng hợp dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-tong-hop/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-tong-hop',
      router_bumas: '/summary-begin-estimate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nộp cấp trên và xem kết quả',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-nop-va-xem-ket-qua/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-nop-va-xem-ket-qua',
      router_bumas: '/begin-year-arrgrate/submitEstimate',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận phương án phân bổ từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-nhan-phuong-an-phan-bo-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-nhan-phuong-an-phan-bo-tu-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-thuc-hien-phan-bo/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-thuc-hien-phan-bo',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập quyết định giao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-lap-quyet-dinh-giao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-lap-quyet-dinh-giao',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Theo dõi giao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-nhan-phuong-an-phan-bo-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-nhan-phuong-an-phan-bo-tu-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Theo dõi thực hiện dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-theo-doi-thuc-hien-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-theo-doi-thuc-hien-du-toan',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhập khẩu dữ liệu năm trước',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/phong-tai-chinh-nhap-khau-du-lieu-nam-truoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=phong-tai-chinh-nhap-khau-du-lieu-nam-truoc',
      router_bumas: '/beforedata',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'In báo cáo',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-in-bao-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-in-bao-cao',
      router_bumas: '/report',
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập và ban hành biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-thiet-lap-va-ban-hanh-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-thiet-lap-va-ban-hanh-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra và tổng hợp biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/ptc-kiem-tra-va-tong-hop-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=ptc-kiem-tra-va-tong-hop-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [2],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập danh mục ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-thiet-lap-danh-muc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-thiet-lap-danh-muc',
      router_bumas: '/dictionaryV3',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Ban hành hướng dẫn lập dự toán ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-ban-hanh-huong-dan-lap-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-ban-hanh-huong-dan-lap-du-toan',
      router_bumas: '/dictionary-enact',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra dự toán ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-kiem-tra-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-kiem-tra-du-toan',
      router_bumas: '/examine',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Tổng hợp dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-tong-hop-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-tong-hop-du-toan',
      router_bumas: '/summary-begin-estimate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu NSNN',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-lap-du-toan-thu-nsnn/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-lap-du-toan-thu-nsnn',
      router_bumas: 'EstimateBudgetArrgrate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán thu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-lap-du-toan-thu-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-lap-du-toan-thu-khac',
      router_bumas: 'RevenueOtherArrgrate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi đầu tư phát triển',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-lap-du-toan-chi-dau-tu/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-lap-du-toan-chi-dau-tu',
      router_bumas: 'EstimateInvestArrgrateSTC',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi thường xuyên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-lap-du-toan-chi-thuong-xuyen/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-lap-du-toan-chi-thuong-xuyen',
      router_bumas: 'ExpenseRegularArrgrate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi CTMT, mục tiêu khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-lap-du-toan-chi-ctmt-muc-tieu-khac/',
      url_help_api:
        'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-lap-du-toan-chi-ctmt-muc-tieu-khac',
      router_bumas: 'ExpenseProgramArrgrate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Lập dự toán chi khác',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-lap-du-toan-chi-khac/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-lap-du-toan-chi-khac',
      router_bumas: 'ExpenseEstimateOtherByLawArrgrate',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Cân đối dự toán',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-can-doi-du-toan/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-can-doi-du-toan',
      router_bumas: '/begin-year-arrgrate/summaryEstimateArrgrateSTC',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhận phương án từ cấp trên',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-nhan-phuong-an-tu-cap-tren/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-nhan-phuong-an-tu-cap-tren',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-thuc-hien-phan-bo/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-thuc-hien-phan-bo',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Quyết định giao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-lap-quyet-dinh-giao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-lap-quyet-dinh-giao',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Theo dõi giao',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-theo-doi-giao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-theo-doi-giao',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Nhập khẩu dữ liệu năm trước',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/so-tai-chinh-nhap-khau-du-lieu-nam-truoc/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=so-tai-chinh-nhap-khau-du-lieu-nam-truoc',
      router_bumas: '/beforedata',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'In báo cáo',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-in-bao-cao/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-in-bao-cao',
      router_bumas: '/report',
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thiết lập và ban hành biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-thiet-lap-va-ban-hanh-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-thiet-lap-va-ban-hanh-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Kiểm tra và tổng hợp biểu mẫu',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/stc-kiem-tra-va-tong-hop-bieu-mau/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=stc-kiem-tra-va-tong-hop-bieu-mau',
      router_bumas: null,
      organization_pack_code_type: [1],
      is_gel_sys_setup: null,
    },
    {
      help_link_name: 'Thực hiện phân bổ',
      url_help: 'https://bumashelp.misa.vn/v2/knowledge-base/scq-thuc-hien-phan-bo/',
      url_help_api: 'https://bumashelp.misa.vn/wp-json/wp/v2/ht-kb/?slug=scq-thuc-hien-phan-bo',
      router_bumas: '/allocation-implement-scq',
      organization_pack_code_type: [5],
      is_gel_sys_setup: null,
    },
  ],
};
